import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { ChecklistTask } from '../../common/ChecklistTask';
import { staggeredBaseQuery } from './staggeredBaseQuery'; 

export const checklistApi = createApi({
  reducerPath: 'checklistApi',
  tagTypes: ['Checklist'],
  baseQuery: staggeredBaseQuery(''),
  endpoints: (builder) => ({
    getChecklist: builder.query<ChecklistTask, number>({
      query: (checklistId) => {
        return {
          method: 'GET',
          url: `checklists/${checklistId}`,
        };
      },
    }),
    completeChecklist: builder.mutation<ChecklistTask, { checklistId: number, userId: string }>({
      query: ({ checklistId, userId }) => {
        return {
          method: 'POST',
          url: `checklists/${checklistId}/complete?userId=${userId}`,
        };
      },
      invalidatesTags: [{ type: 'Checklist', id: 'LIST' }],
    }),
    reopenChecklist: builder.mutation<ChecklistTask, number>({
      query: (checklistId) => {
        return {
          method: 'POST',
          url: `checklists/${checklistId}/reopen`,
        };
      },
      invalidatesTags: [{ type: 'Checklist', id: 'LIST' }],
    }),
    markNotApplicable: builder.mutation<ChecklistTask, { checklistId: number, userId: string }>({
      query: ({ checklistId, userId }) => {
        return {
          method: 'POST',
          url: `checklists/${checklistId}/markNotApplicable?userId=${userId}`,
        };
      },
      invalidatesTags: [{ type: 'Checklist', id: 'LIST' }],
    }),
    unmarkNotApplicable: builder.mutation<ChecklistTask, number>({
      query: (checklistId) => {
        return {
          method: 'POST',
          url: `checklists/${checklistId}/unmarkNotApplicable`,
        };
      },
      invalidatesTags: [{ type: 'Checklist', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetChecklistQuery,
  useCompleteChecklistMutation,
  useReopenChecklistMutation,
  useMarkNotApplicableMutation,
  useUnmarkNotApplicableMutation,
} = checklistApi;